<template>
  <div>
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader"></h3>
    <!-- <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="设备名">
        </custom-table-column>
        <custom-table-column prop="devSerialNum" label="序列号">
        </custom-table-column>
        <custom-table-column prop="statusText" label="设备状态">
        </custom-table-column>
        <custom-table-column prop="deviceModel" label="设备型号">
        </custom-table-column>
        <custom-table-column prop="deviceType" label="设备类型">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
              <el-button @click="handleApplyPwd(scope.row.indexCode)" type="text" size="small">临时密码授权</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
   
    <el-dialog :close-on-click-modal="false" title="授权申请" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="使用开始时间" prop="use_start_time">
          <el-date-picker type="datetime" placeholder="请选择" clearable  value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.use_start_time" style="width: 216px;" ></el-date-picker>
        </el-form-item>
        <el-form-item label="使用结束时间" prop="use_end_time">
          <el-date-picker type="datetime" placeholder="请选择" clearable  value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.use_end_time" style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="使用说明" prop="reason">
          <el-input type="textarea" v-model="ruleForm.reason"  :rows="5" placeholder="请输入"
            style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" 
            @click="submitFormByFun('ruleForm', updateMethod)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';

export default {
  name: 'equipmentInto',
  mixins: [mixinList],
  data() {
    return {
      formInline: {
      },
      ruleForm: {
        device_index_code:'',
        use_start_time:'',
        use_end_time:'',
        reason:''
      },
      rules: {
        reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        use_start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        use_end_time: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      tableData1: [],
      total1: 0,
      loading: false,
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleApplyPwd(device_index_code){
      this.ruleForm.device_index_code = device_index_code
      this.centerDialogVisible = true
    },
    
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/smart_lock/smart-lock-auth/submit`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '申请成功！',
        });
        this.centerDialogVisible = false
      }
    },
    async getOfflineCode(device_index_code) {
      let params = { device_index_code };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/offline-password', 'post', params);
      if (res.code == 0 && res.data) {
        if (res.data.offlineCode) {
          this.codeWin(res.data.offlineCode, '离线开门口令')
        } else {
          this.$message({
            type: 'warning',
            message: `未找到口令!`,
          });
        }
      }
    },
    async getTemPwd(device_index_code) {
      let params = { device_index_code };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/generate-temp-password', 'post', params);
      if (res.code == 0 && res.data) {
        if (res.data.password) {
          this.codeWin(res.data.password, '临时密码')
        } else {
          this.$message({
            type: 'warning',
            message: `未找到临时密码!`,
          });
        }
      }
    },
    codeWin(code, title) {
      const html = this.$createElement
      let spans = []
      for (let i = 0; i < code.length; i++) {
        spans.push(<span class='lock-code'>{code[i]}</span>)
      }
      this.$msgbox({
        title,
        message: html('div', { class: 'lock-box' }, spans),
        showCancelButton: false,
        showConfirmButton: false,
      }).then(action => {
      });
    },
    handleOpen(indexCode, operation_type, str) {
      this.$confirm(`此操作将${str}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.openLock(indexCode, operation_type);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async openLock(device_index_code, operation_type) {
      let params = { device_index_code, operation_type };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/open-door', 'get', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `操作成功!`,
        });
      }
    },
    async getList() {
      // this.tableData = [{ "indexCode": "7b397039fbf840f7ab408199e0cddc24", "name": "精勤楼网关130", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "offline", "parentIndexCode": null, "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8622636", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "离线" }, { "indexCode": "4789a739ec3642d48d67aeada2155c05", "name": "精勤楼111", "deviceType": "gatewayLock", "deviceModel": "CS-LT70-V100-RBCP", "deviceStatus": "online", "parentIndexCode": "7b397039fbf840f7ab408199e0cddc24", "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8623683", "capability": "@isSupportFingerPwd@support_person@support_offlinepassword@support_finger@support_doorHolidayPlan@support_doorsensor@support_card@support_temporaryPassword@support_doorstatus@support_add_psw@", "description": "BF8622636", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "42f9b23090dc41998683f828727fe8ab", "name": "精勤楼113", "deviceType": "gatewayLock", "deviceModel": "CS-LT70-V100-RBCP", "deviceStatus": "online", "parentIndexCode": "7b397039fbf840f7ab408199e0cddc24", "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8623657", "capability": "@isSupportFingerPwd@support_person@support_offlinepassword@support_finger@support_doorHolidayPlan@support_doorsensor@support_card@support_temporaryPassword@support_doorstatus@support_add_psw@", "description": "BF8622636", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "acea67fe02cb46b18d157bd6649ee8c8", "name": "精勤楼网关132", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8622615", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "b6043b2d0a8243a79278978f71ec6c16", "name": "精勤楼网关136", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "成都铁路卫生学校", "regionPath": "@root000000@", "devSerialNum": "BF8622609", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "d8004bc8c44e43a7bd8e5d0aa1e0dbd9", "name": "精勤楼网关135", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "成都铁路卫生学校", "regionPath": "@root000000@", "devSerialNum": "BF8622580", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }]
      // this.total = 20
      // return
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.lock-box {
  text-align: center;
  padding: 24px 0;

  span {
    padding: 6px;
    margin: 4px 8px;
    font-size: 22px;
    border-radius: 4px;
    // text-decoration: underline;
    border: 1px solid #cfcfcf;
  }
}

@media screen and (max-width: 1000px) {
  .pageHeader {
    border-bottom: 0;
  }

  /deep/.header-info-icon {
    bottom: 18px;
  }
}

@media screen and (min-width: 1000px) {
  .pageHeader {
    display: none;
  }
}

.pageHeader:before {
  width: var(--width);
}
</style>
